import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <Navbar />
      <div className="max-w-lg mx-auto px-6 py-16 text-center">
        <XCircle className="w-14 h-14 text-red-500 mx-auto" />
        <h1 className="font-display font-black text-4xl tracking-tighter mt-6">Pago cancelado</h1>
        <p className="text-zinc-500 mt-2">Tu carrito sigue vacío. Puedes intentarlo de nuevo.</p>
        <Link to="/"><Button className="mt-6 rounded-sm bg-zinc-900 hover:bg-zinc-800">Volver al catálogo</Button></Link>
      </div>
    </div>
  );
}
